import { render, staticRenderFns } from "./quickLinkEdit.vue?vue&type=template&id=2c10895d&scoped=true&"
import script from "./quickLinkEdit.vue?vue&type=script&lang=js&"
export * from "./quickLinkEdit.vue?vue&type=script&lang=js&"
import style0 from "./quickLinkEdit.vue?vue&type=style&index=0&id=2c10895d&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c10895d",
  null
  
)

export default component.exports